<template>



          <v-overlay
            :absolute="absolute"
            :value="overlay"
          >
          <v-container>

            <v-row align="center" justify="center">
              <v-row justify="center">
                  <div>{{message}}</div>
              </v-row>
                <v-row justify="center">
            <v-progress-circular
                v-if="loggingin"
                :size="200"
                :width="7"
                color="secondary"
                indeterminate
              ></v-progress-circular>


        </v-row>

    </v-row>
    </v-container>
  </v-overlay>











</template>

<script>
  import ShuttleMixins from '@/mixins/ShuttleMixins.js';
export default {
  name: 'processLogin',
  mixins:[ShuttleMixins],
  data() {
    return {
      loggingin: true,
      message:'Validating Login',
      retries:0,
      maxretries:2,
      absolute:true,
      overlay:true,
    }
  },

  methods: {

       async validateLogin(){
          this.$store.commit('removeOverlay');
          var authresponse  = await this.authorizeCognitoUser();

          if (authresponse.AuthenticationResult) {
            if (authresponse.AuthenticationResult.IdToken) {
              var new_creds = {
                hashtokens: {
                    access_token: authresponse.AuthenticationResult.AccessToken,
                    expires_in: 3600,
                    id_token: authresponse.AuthenticationResult.IdToken,
                    refresh_token: this.$store.state.hashtokens.refresh_token,
                    token_type: 'Bearer'
                },
                auth: this.$store.state.auth
              };
              this.$store.commit('setUserAuthCredentials', new_creds);
              ////console.log("*** UPDATED NEW CREDENTIALS ***");
            }
          }

          //console.log(authresponse);
          if (authresponse.errorType){
              //console.log('Error');
              this.message = authresponse.errorType;
              this.loggingin = false;
              if (authresponse.errorType == "TokenExpiredError") {

              }

              var vm = this;
              this.$store.dispatch('signOut').then((result) => {
                //console.log("LOGGING OUT / SIGNING OUT");
                //console.log(result);
                vm.$router.push({name:'Login'});
              }).catch((err) => {
                //console.log("LOGGING OUT / SIGNING OUT : CATCH ERROR");
                //console.log(err);
                vm.$router.push({name:'Login'});
              });

          } else{


              // login success, now verify and get data from cognito
              //this.$store.commit('auth', authresponse);


              this.checkUser();
              //this.$router.push({path:'/studio/list/' + sub})

          }


      },







      async checkUser(){


        this.message = 'Checking User info..'

        let path  = this.$store.state.endpoint.post_customer + '/' +this.$store.state.auth.sub;
        let userinfo = await this.getData( path,'get');
        ////console.log(JSON.stringify(userinfo));

        var customer_exists = false;

        try{
          if(userinfo){
              if(userinfo.hasOwnProperty('Item')){
                  if(userinfo.Item.customer_id){
                      customer_exists = true;
                  }

              }
            }
          } catch(e){

            this.message = 'Could not find shuttle account. Creating now...'
          }


        if(customer_exists){
          //customer exists



        var json = this.dynamoUnMarshall(userinfo.Item);

        //console.log(json)
        this.$store.commit('dynamo', json);
        ////console.log(this.$store.state.dynamo.customer_id)
        this.$router.push({path:'/studio/list/' + this.$store.state.dynamo.customer_id})
        } else {

            this.message = 'Creating user settings.'

            let path  = this.$store.state.endpoint.post_customer;
            let postdata = {"customer_id":this.$store.state.auth.sub};
            let userinfo = await this.getData( path,'post',postdata);
            ////console.log(userinfo);


            if(userinfo.message){

              this.message = userinfo.message;
            } else {

              this.retries = this.retries + 1;
              if (this.retries < this.maxretries){
                  this.checkUser();
              } else {

                this.message = "some other error. too many retries.";
              }

            }



        }


      }

  },


  mounted() {
        this.validateLogin();

    },

}
</script>
